/* tslint:disable */
import { ActionContext } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { setVuexKeys } from "@src/store/StoreHelper";
import { FeatureFlagState } from "@app/shared/featureFlag/stores/featureFlagState";
import { FeatureFlagController } from "@src/proxy/FeatureFlagController";
import { FeatureFlagType } from "@src/proxy/FeatureFlagType";
import * as _ from "lodash";

type FeatureFlagStateContext = ActionContext<FeatureFlagState, any>;

const FeatureFlagStore = {
    namespaced: true,
    state: new FeatureFlagState(),
    mutations: {
        updateFeatureFlags(state: FeatureFlagState, featureFlags: Array<ProxyModel.FeatureFlagViewModel>) {
            state.featureFlags = featureFlags;
        }
    },
    getters: {
        isFeatureFlagEnabled: (state: FeatureFlagState) => (featureFlag: FeatureFlagType): boolean => {
            let feature = _.find(state.featureFlags, (value) => {
                return value.type === featureFlag;
            });

            return feature ? feature.isEnabled : false;
        }
    },
    actions: {
        isFeatureFlagEnabled: async (context: FeatureFlagStateContext, featureFlag: FeatureFlagType): Promise<boolean> => {
            if (context.state.featureFlags) {
                return context.getters.isFeatureFlagEnabled(featureFlag);
            } else {
                return await new FeatureFlagController().getAllFeatureFlags().then(response => {
                    context.commit("updateFeatureFlags", response.successData);
                    return context.getters.isFeatureFlagEnabled(featureFlag);
                });
            }
        }
    }
};
export default FeatureFlagStore;

const { dispatch } = getStoreAccessors<FeatureFlagState, any>("featureFlagStore");
const actions = setVuexKeys(FeatureFlagStore.actions);
export const isFeatureFlagEnabled = dispatch(actions.isFeatureFlagEnabled);
